import Breadcrumb from "components/Common/Breadcrumb"
import SelectBox from "components/Common/SelectBox"
import {
  getCorporateOrdersApi,
  getCSVDataApi,
  getSeasonListApi,
  getSupplierListApi,
  getYearListApi,
} from "helpers/corporate_orders"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap"

import {
  dateMaps,
  defaultCSVParams,
  defaultSearchParams,
  defaultSelect,
  yearsOption,
} from "./default-values"
import Table from "./Table"
import Skeleton from "react-loading-skeleton"
import DateInput from "components/Common/DateInput"
import moment from "moment"

export default function CorporateOrders() {
  const [isFetching, setIsFetching] = useState(false)
  const history = useHistory()
  const [data, setData] = useState()

  // fetch parameters
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [searchParams, setSearchparams] = useState(defaultSearchParams)
  const [csvParams, setCsvParams] = useState(defaultCSVParams) // ini kalo sama dengan searchParams pakek 1 aja nanti tinggal delete aja yang gak kepakek jadi gak perlu buat 2 kayak gini
  const [count, setCount] = useState(100)

  // select options
  const [supplierNames, setSupplierNames] = useState([])
  const [seasons, setSeasons] = useState([])

  // select values
  const [supplierValue, setSupplierValue] = useState(defaultSelect)
  const [yearValue, setYearValue] = useState(defaultSelect)
  const [seasonValue, setSeasonValue] = useState(defaultSelect)

  const loadData = async (params = searchParams) => {
    setIsFetching(true)
    try {
      const res = await getCorporateOrdersApi({
        ...params,
        page: pagination.page,
        size: pagination.size,
        orderDateFrom:
          params.orderDateFrom !== ""
            ? moment(params.orderDateFrom).format("YYYY-MM-DD")
            : "",
        orderDateTo:
          params.orderDateTo !== ""
            ? moment(params.orderDateTo).format("YYYY-MM-DD")
            : "",
        scheduledDeliveryDateFrom:
          params.scheduledDeliveryDateFrom !== ""
            ? moment(params.scheduledDeliveryDateFrom).format("YYYY-MM-DD")
            : "",
        scheduledDeliveryDateTo:
          params.scheduledDeliveryDateTo !== ""
            ? moment(params.scheduledDeliveryDateTo).format("YYYY-MM-DD")
            : "",
        deliveryDateFrom:
          params.deliveryDateFrom !== ""
            ? moment(params.deliveryDateFrom).format("YYYY-MM-DD")
            : "",
        deliveryDateTo:
          params.deliveryDateTo !== ""
            ? moment(params.deliveryDateTo).format("YYYY-MM-DD")
            : "",
      })
      setData(res.data.content)
      setCount(res.data.totalPages)
      setTimeout(() => {
        setIsFetching(false)
      }, 10)
    } catch (error) {
      console.log(error)
    }
  }

  const onSearch = async (params = searchParams) => {
    setPagination({ page: 0, size: 10 })
    setIsFetching(true)
    try {
      const res = await getCorporateOrdersApi({
        ...params,
        orderDateFrom:
          params.orderDateFrom !== ""
            ? moment(params.orderDateFrom).format("YYYY-MM-DD")
            : "",
        orderDateTo:
          params.orderDateTo !== ""
            ? moment(params.orderDateTo).format("YYYY-MM-DD")
            : "",
        scheduledDeliveryDateFrom:
          params.scheduledDeliveryDateFrom !== ""
            ? moment(params.scheduledDeliveryDateFrom).format("YYYY-MM-DD")
            : "",
        scheduledDeliveryDateTo:
          params.scheduledDeliveryDateTo !== ""
            ? moment(params.scheduledDeliveryDateTo).format("YYYY-MM-DD")
            : "",
        deliveryDateFrom:
          params.deliveryDateFrom !== ""
            ? moment(params.deliveryDateFrom).format("YYYY-MM-DD")
            : "",
        deliveryDateTo:
          params.deliveryDateTo !== ""
            ? moment(params.deliveryDateTo).format("YYYY-MM-DD")
            : "",
      })
      setData(res.data.content)
      setCount(res.data.totalPages)
      setTimeout(() => {
        setIsFetching(false)
      }, 10)
    } catch (error) {
      console.log(error)
    }
  }

  const loadSuppliers = async () => {
    try {
      const res = await getSupplierListApi()
      const _supplierNames = res.data.map(item => ({
        label: `${item.code} - ${item.name}`,
        value: item.code,
        org: item,
        id: item.id,
        param: { name: "supplierName", value: item.name },
      }))
      setSupplierNames(_supplierNames)
    } catch (error) {
      console.log(error)
    }
  }

  const loadSeasons = async () => {
    try {
      const res = await getSeasonListApi()
      const _seasons = res.data.map(item => ({
        label: `${item.name}`,
        value: item.id,
      }))
      setSeasons(_seasons)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadData()
  }, [pagination])

  useEffect(() => {
    loadSuppliers()
    loadSeasons()
  }, [])

  const handleSupplierSelect = v => {
    setSupplierValue(v || "")

    const _searchParams = { ...searchParams }
    const _csvParams = { ...csvParams }
    _searchParams.supplierName = v?.param?.value || ""
    _csvParams.supplierName = v?.param?.value || ""

    setSearchparams(_searchParams)
    setCsvParams(_csvParams)
  }

  const handleYearSelect = v => {
    setYearValue(v || "")
    const _searchParams = { ...searchParams }
    _searchParams.year = v?.value || ""
    setSearchparams(_searchParams)
  }

  const handleSeasonSelect = v => {
    setSeasonValue(v || "")
    const _searchParams = { ...searchParams }
    _searchParams.seasonId = v?.value || ""
    setSearchparams(_searchParams)
  }

  const handleCreate = () => history.push("/corporate-orders/create")

  const handleEdit = (id, status) => {
    // if (status !== "新規注文") return
    history.push({
      pathname: `/corporate-orders/edit`,
      state: { id: id },
      search: `?id=${id}`,
    })
  }

  // const handleDateInput = (e, name) => {
  //   let d0 = "",
  //     d1 = ""
  //   if (isValidDate(e[0])) d0 = new Date(e[0]).toISOString().slice(0, 10)
  //   if (isValidDate(e[1])) d1 = new Date(e[1]).toISOString().slice(0, 10)

  //   const _searchParams = { ...searchParams }
  //   const _csvParams = { ...csvParams }
  //   _searchParams[dateMaps[name][0]] = d0
  //   _searchParams[dateMaps[name][1]] = d1
  //   _csvParams[dateMaps[name][0]] = d0
  //   _csvParams[dateMaps[name][1]] = d1
  //   setSearchparams(_searchParams)
  //   setCsvParams(_csvParams)
  //   return
  // }

  const downLoadCsv = async (params = searchParams) => {
    try {
      const { data } = await getCSVDataApi(params)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "text/csv;charset=utf-8;" })
      )
      link.setAttribute("download", "report" + new Date().getTime() + ".csv")
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"RTW法人受注詳細"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col sm={4}>
                <Label sm={4}>取引先</Label>
                <SelectBox
                  options={supplierNames}
                  value={supplierValue}
                  onChange={v => handleSupplierSelect(v)}
                />
              </Col>

              <Col sm={4}>
                <Label sm={4}>年度</Label>
                <SelectBox
                  options={yearsOption}
                  value={yearValue}
                  onChange={v => handleYearSelect(v)}
                />
              </Col>
              <Col sm={4}>
                <Label sm={4}>シーズン</Label>
                <SelectBox
                  options={seasons}
                  value={seasonValue}
                  onChange={v => handleSeasonSelect(v)}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col sm={4}>
                <Label>受注日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    value={searchParams.orderDateFrom}
                    onChange={date => {
                      setSearchparams({
                        ...searchParams,
                        orderDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        orderDateFrom: "",
                      })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    value={searchParams.orderDateTo}
                    minDate={searchParams.orderDateFrom}
                    onChange={date =>
                      setSearchparams({ ...searchParams, orderDateTo: date[0] })
                    }
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        orderDateTo: "",
                      })
                    }
                  />
                </div>
              </Col>
              <Col sm={4}>
                <Label>納品予定日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    value={searchParams.scheduledDeliveryDateFrom}
                    onChange={date => {
                      setSearchparams({
                        ...searchParams,
                        scheduledDeliveryDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        scheduledDeliveryDateFrom: "",
                      })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    value={searchParams.scheduledDeliveryDateTo}
                    minDate={searchParams.scheduledDeliveryDateFrom}
                    onChange={date =>
                      setSearchparams({
                        ...searchParams,
                        scheduledDeliveryDateTo: date[0],
                      })
                    }
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        scheduledDeliveryDateTo: "",
                      })
                    }
                  />
                </div>
              </Col>
              <Col sm={4}>
                <Label>納品日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    value={searchParams.deliveryDateFrom}
                    onChange={date => {
                      setSearchparams({
                        ...searchParams,
                        deliveryDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        deliveryDateFrom: "",
                      })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    value={searchParams.deliveryDateTo}
                    minDate={searchParams.deliveryDateFrom}
                    onChange={date =>
                      setSearchparams({
                        ...searchParams,
                        deliveryDateTo: date[0],
                      })
                    }
                    clear={() =>
                      setSearchparams({
                        ...searchParams,
                        deliveryDateTo: "",
                      })
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row className="justify-content-end">
              <Col
                sm={3}
                className="d-flex justify-content-end align-items-end gap-2"
              >
                <Button
                  className="button"
                  onClick={() => {
                    onSearch()
                  }}
                >
                  検索
                </Button>
                <Button className="button" onClick={() => downLoadCsv()}>
                  CSV出力
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col sm={12} className="d-flex justify-content-end">
                <Button className="button" onClick={handleCreate}>
                  新規受注
                </Button>
              </Col>
            </Row>
            {isFetching ? (
              <Skeleton count={5} />
            ) : (
              <Table
                page={pagination.page}
                content={data}
                size={pagination.size}
                count={count}
                params={pagination}
                setParams={setPagination}
                handleEdit={handleEdit}
              />
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

// ini kalo gak kepakek delete aja
export function CustomPagination({ activePage, pageNumber, navigatePage }) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <Pagination>
        <PaginationItem onClick={() => navigatePage("prev")}>
          <PaginationLink previous />
        </PaginationItem>

        {Array.from({ length: pageNumber }, (_, i) => i + 1).map(num => (
          <PaginationItem
            key={num}
            active={activePage === num}
            onClick={() => navigatePage(num)}
          >
            <PaginationLink>{num}</PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem onClick={() => navigatePage("next")}>
          <PaginationLink next />
        </PaginationItem>
      </Pagination>
    </div>
  )
}
